import type { IconType } from 'react-icons'
import { useMhlScope } from './useMhlScope'

export type MhlScopeRequirement = 'canViewStats' | 'isTeamLeader'

interface Props {
    path: string
    label: string
    Icon: IconType
    /** Which scope flag must be true for the link to render. */
    requires: MhlScopeRequirement
    active: boolean
    className: string
    onNavigate: (path: string) => void
}

/**
 * Sidebar link that only renders when the server-declared MHL scope grants
 * the required flag (team leaders for overview, stats and the agents list).
 * Admins use the admin sidebar, so this is only used in the agent variant.
 */
export const MhlScopedNavItem = ({ path, label, Icon, requires, active, className, onNavigate }: Props) => {
    const { scope } = useMhlScope()
    if (!scope?.[requires]) return null
    return (
        <li className={active ? className : ''}>
            <a onClick={() => onNavigate(path)}>
                <Icon /> {label}
            </a>
        </li>
    )
}
